(() => {
  const init = (scope = document) => {
    const menu = scope.querySelector('.menu-toggle');
    if (menu && !menu.dataset.initialized) {
      menu.dataset.initialized = 'true';
      const nav = document.getElementById(menu.getAttribute('aria-controls'));
      const close = () => { nav?.querySelectorAll('details[open]').forEach(d => d.open = false); menu.setAttribute('aria-expanded', 'false'); nav?.classList.remove('is-open'); };
      menu.addEventListener('click', () => { const open = menu.getAttribute('aria-expanded') !== 'true'; menu.setAttribute('aria-expanded', String(open)); nav?.classList.toggle('is-open', open); });
      nav?.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); menu.focus(); } });
      menu.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
    }
    scope.querySelectorAll('[data-product]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
      const policy = JSON.parse(root.querySelector('[data-product-policy]').textContent);
      const select = root.querySelector('[data-variant-select]');
      const image = root.querySelector('#ProductMainImage');
      const setImage = (src, alt) => { if (image && src) { image.src = src; image.removeAttribute('srcset'); image.alt = alt || policy.title; } };
      const update = id => {
        const variant = variants.find(v => String(v.id) === String(id));
        if (!variant) return;
        if (select) select.value = String(variant.id);
        root.querySelector('[data-sku]').textContent = variant.sku || 'SKU pending';
        if (select) root.querySelector('[data-pack]').textContent = variant.title;
        root.querySelector('[data-price]').textContent = policy.priceConfirmed ? variant.price : 'Ask for price';
        root.querySelector('[data-availability]').textContent = !policy.canPurchase ? 'Product enquiry' : variant.available ? 'Available' : 'Out of stock';
        const add = root.querySelector('[data-add]');
        if (add) { add.disabled = !variant.available || !policy.canPurchase; add.textContent = variant.available && policy.canPurchase ? 'Add to cart' : 'Out of stock'; }
        const quantity = root.querySelector('[name=quantity]');
        if (quantity) { quantity.min = variant.quantityMin; quantity.step = variant.quantityStep; if (variant.quantityMax) quantity.max = variant.quantityMax; else quantity.removeAttribute('max'); quantity.value = variant.quantityMin; }
        const inquiry = root.querySelector('[data-inquiry]');
        const contact = new URL(policy.contactUrl, location.origin);
        contact.searchParams.set('product', policy.title + (select ? ' — ' + variant.title : ''));
        inquiry.href = contact.pathname + contact.search;
        setImage(variant.image || policy.fallbackImage, variant.alt || policy.title);
        root.querySelector('[data-image-note]').textContent = select ? (variant.image ? 'Selected pack photo.' : 'Packaging shown for reference. Confirm the selected strength and pack.') : '';
        root.querySelectorAll('[data-gallery-src]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gallerySrc === (variant.image || policy.fallbackImage))));
      };
      select?.addEventListener('change', () => { update(select.value); const url = new URL(location.href); url.searchParams.set('variant', select.value); history.pushState({}, '', url); });
      window.addEventListener('popstate', () => update(new URL(location.href).searchParams.get('variant') || variants[0].id));
      root.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => { setImage(button.dataset.gallerySrc, button.dataset.galleryAlt); root.querySelectorAll('[data-gallery-src]').forEach(other => other.setAttribute('aria-pressed', String(other === button))); }));
      const form = root.querySelector('.product-form');
      form.addEventListener('submit', e => {
        if (!policy.canPurchase) { e.preventDefault(); return; }
        const id = new FormData(form).get('id');
        if (!variants.find(v => String(v.id) === String(id))?.available) e.preventDefault();
      });
      update(select?.value || variants[0].id);
    });
    scope.querySelectorAll('[data-article-content]').forEach(content => {
      if (content.dataset.initialized) return;
      content.dataset.initialized = 'true';
      const toc = scope.querySelector('[data-toc]');
      if (!toc) return;
      const used = new Set([...document.querySelectorAll('[id]')].map(e => e.id));
      content.querySelectorAll('h2,h3').forEach((heading, i) => {
        if (!heading.id) { let id = 'care-note-section-' + (i + 1); while (used.has(id)) id += '-a'; heading.id = id; used.add(id); }
        const link = document.createElement('a'); link.href = '#' + encodeURIComponent(heading.id); link.textContent = heading.textContent; link.dataset.depth = heading.tagName === 'H3' ? '3' : '2'; toc.append(link);
      });
      if (!toc.children.length) toc.closest('details').hidden = true;
    });
    scope.querySelectorAll('[data-copy-link]').forEach(button => {
      if (button.dataset.initialized) return; button.dataset.initialized = 'true';
      button.addEventListener('click', async () => {
        const status = button.parentElement.querySelector('[data-copy-status]');
        try { await navigator.clipboard.writeText(location.href.split('#')[0]); status.textContent = ' Link copied.'; }
        catch { status.textContent = ' Copy the URL from your address bar.'; }
      });
    });
    const productInput = scope.querySelector('#ContactProduct');
    if (productInput && !productInput.value) productInput.value = new URL(location.href).searchParams.get('product') || '';
    scope.querySelector('[role=alert][tabindex]')?.focus();
  };
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

(() => {
  const init = () => {
    const header = document.querySelector('.header');
    if (!header || header.dataset.navigationInitialized) return;
    header.dataset.navigationInitialized = 'true';
    const disclosures = [...header.querySelectorAll('.nav-disclosure')];
    const close = () => disclosures.forEach(d => d.open = false);
    disclosures.forEach(d => {
      d.querySelector('summary').addEventListener('click', () => disclosures.filter(other => other !== d).forEach(other => other.open = false));
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', e => { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => {
    const header = document.querySelector('.header');
    if (!header || header.dataset.navigationInitialized) return;
    header.dataset.navigationInitialized = 'true';
    const disclosures = [...header.querySelectorAll('.nav-disclosure')];
    const close = () => disclosures.forEach(d => d.open = false);
    disclosures.forEach(d => {
      d.querySelector('summary').addEventListener('click', () => disclosures.filter(other => other !== d).forEach(other => other.open = false));
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', e => { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => {
    const header = document.querySelector('.header');
    if (!header || header.dataset.navigationInitialized) return;
    header.dataset.navigationInitialized = 'true';
    const disclosures = [...header.querySelectorAll('.nav-disclosure')];
    const close = () => disclosures.forEach(d => d.open = false);
    disclosures.forEach(d => {
      d.querySelector('summary').addEventListener('click', () => disclosures.filter(other => other !== d).forEach(other => other.open = false));
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', e => { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => {
    const header = document.querySelector('.header');
    if (!header || header.dataset.navigationInitialized) return;
    header.dataset.navigationInitialized = 'true';
    const disclosures = [...header.querySelectorAll('.nav-disclosure')];
    const close = () => disclosures.forEach(d => d.open = false);
    disclosures.forEach(d => {
      d.querySelector('summary').addEventListener('click', () => disclosures.filter(other => other !== d).forEach(other => other.open = false));
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', e => { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => {
    const header = document.querySelector('.header');
    if (!header || header.dataset.navigationInitialized) return;
    header.dataset.navigationInitialized = 'true';
    const disclosures = [...header.querySelectorAll('.nav-disclosure')];
    const close = () => disclosures.forEach(d => d.open = false);
    disclosures.forEach(d => {
      d.querySelector('summary').addEventListener('click', () => disclosures.filter(other => other !== d).forEach(other => other.open = false));
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', e => { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => {
    const header = document.querySelector('.header');
    if (!header || header.dataset.navigationInitialized) return;
    header.dataset.navigationInitialized = 'true';
    const disclosures = [...header.querySelectorAll('.nav-disclosure')];
    const close = () => disclosures.forEach(d => d.open = false);
    disclosures.forEach(d => {
      d.querySelector('summary').addEventListener('click', () => disclosures.filter(other => other !== d).forEach(other => other.open = false));
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', e => { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => {
    const header = document.querySelector('.header');
    if (!header || header.dataset.navigationInitialized) return;
    header.dataset.navigationInitialized = 'true';
    const disclosures = [...header.querySelectorAll('.nav-disclosure')];
    const close = () => disclosures.forEach(d => d.open = false);
    disclosures.forEach(d => {
      d.querySelector('summary').addEventListener('click', () => disclosures.filter(other => other !== d).forEach(other => other.open = false));
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', e => { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => {
    const header = document.querySelector('.header');
    if (!header || header.dataset.navigationInitialized) return;
    header.dataset.navigationInitialized = 'true';
    const disclosures = [...header.querySelectorAll('.nav-disclosure')];
    const close = () => disclosures.forEach(d => d.open = false);
    disclosures.forEach(d => {
      d.querySelector('summary').addEventListener('click', () => disclosures.filter(other => other !== d).forEach(other => other.open = false));
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', e => { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => {
    const header = document.querySelector('.header');
    if (!header || header.dataset.navigationInitialized) return;
    header.dataset.navigationInitialized = 'true';
    const disclosures = [...header.querySelectorAll('.nav-disclosure')];
    const close = () => disclosures.forEach(d => d.open = false);
    disclosures.forEach(d => {
      d.querySelector('summary').addEventListener('click', () => disclosures.filter(other => other !== d).forEach(other => other.open = false));
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', e => { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => {
    const header = document.querySelector('.header');
    if (!header || header.dataset.navigationInitialized) return;
    header.dataset.navigationInitialized = 'true';
    const disclosures = [...header.querySelectorAll('.nav-disclosure')];
    const close = () => disclosures.forEach(d => d.open = false);
    disclosures.forEach(d => {
      d.querySelector('summary').addEventListener('click', () => disclosures.filter(other => other !== d).forEach(other => other.open = false));
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', e => { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => {
    const header = document.querySelector('.header');
    if (!header || header.dataset.navigationInitialized) return;
    header.dataset.navigationInitialized = 'true';
    const disclosures = [...header.querySelectorAll('.nav-disclosure')];
    const close = () => disclosures.forEach(d => d.open = false);
    disclosures.forEach(d => {
      d.querySelector('summary').addEventListener('click', () => disclosures.filter(other => other !== d).forEach(other => other.open = false));
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', e => { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => {
    const header = document.querySelector('.header');
    if (!header || header.dataset.navigationInitialized) return;
    header.dataset.navigationInitialized = 'true';
    const disclosures = [...header.querySelectorAll('.nav-disclosure')];
    const close = () => disclosures.forEach(d => d.open = false);
    disclosures.forEach(d => {
      d.querySelector('summary').addEventListener('click', () => disclosures.filter(other => other !== d).forEach(other => other.open = false));
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', e => { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => {
    const header = document.querySelector('.header');
    if (!header || header.dataset.navigationInitialized) return;
    header.dataset.navigationInitialized = 'true';
    const disclosures = [...header.querySelectorAll('.nav-disclosure')];
    const close = () => disclosures.forEach(d => d.open = false);
    disclosures.forEach(d => {
      d.querySelector('summary').addEventListener('click', () => disclosures.filter(other => other !== d).forEach(other => other.open = false));
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });
    header.addEventListener('focusout', e => { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(); });
  };
  init(); document.addEventListener('shopify:section:load', init);
})();
